import { render, staticRenderFns } from "./my-user-quiz.vue?vue&type=template&id=5650597f&scoped=true&"
import script from "./my-user-quiz.vue?vue&type=script&lang=js&"
export * from "./my-user-quiz.vue?vue&type=script&lang=js&"
import style0 from "./my-user-quiz.vue?vue&type=style&index=0&id=5650597f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5650597f",
  null
  
)

export default component.exports